import { withTheme, SvyStepper as Stepper } from '@innovorder/savory';

export const SvyStepper = withTheme(Stepper);
